import { render, staticRenderFns } from "./PickupPointEdit.vue?vue&type=template&id=1023e188&"
import script from "./PickupPointEdit.vue?vue&type=script&lang=js&"
export * from "./PickupPointEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports